import {ThemeColorPath} from 'platform/foundation';

import {OptionType} from '../../types/FormControlProps';

export type ColorChipsOption = {
  color: ThemeColorPath;
} & OptionType;
